export const WarningService = (page: string, data: string) => {
    typeof window !== "undefined"
        ? window
        : console.log(
              `\x1b[43m \x1b[30m WARN: \x1b[0m`,
              `${page} : ${data} -> this info cannot be load, check if it's correctly loaded in the CMS !`
          );
};
